import { render, staticRenderFns } from "./AccountTypeSetting.vue?vue&type=template&id=7285ba17"
import script from "./AccountTypeSetting.vue?vue&type=script&lang=js"
export * from "./AccountTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports